function logInfo(...args) {
  // Disabling eslint rule for testing purposes
  // TODO REMOVE THIS DISABLE BEFORE MERGE
  // eslint-disable-next-line no-console
  console.log('pfe monitor', performance.now(), ...args);
}

function logWarn(...args) {
  console.warn('pfe monitor', performance.now(), ...args);
}

function logError(...args) {
  console.error('pfe monitor', performance.now(), ...args);
}

export default {
  logInfo,
  logWarn,
  logError,
};
